exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-tools[data-v-3e6a1b86] {\n  text-align: right;\n}\n.modify_box[data-v-3e6a1b86] {\n  width: 52px;\n  margin-bottom: 10px;\n}\n.notes-btn[data-v-3e6a1b86] {\n  display: block;\n  width: 65px;\n  padding: 0.25rem 0.5rem;\n  margin-bottom: 5px;\n  color: white;\n  /* background-color: cornflowerblue; */\n}\n.status[data-v-3e6a1b86] {\n  display: block;\n  text-align: center;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n.status-rejected[data-v-3e6a1b86] {\n  color: crimson;\n}\n.status-finished[data-v-3e6a1b86] {\n  color: green;\n}", ""]);

// exports
